module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-heading-hakone-8b9d8f58b2cde309c6617d482b716df7.svg";